<template>
  <div class="block-subsc-contents basic-block">
    <h1>配信されるコンテンツ</h1>
    <ol>
      <li>
        <h3>
          <img src="/static/img/lp/campaign/lineCampaign202110/no1.svg" alt="1">
          『占いTV』体験メニュー
        </h3>
        <p>『占いTV』のサブスクリプションメニューから、あなたの悩みに沿った占いを配信！<br>無料で『占いTV』を体験できます。</p>
        <img src="/static/img/lp/campaign/lineCampaign202110/subscContents1.png">
      </li>
      <li>
        <h3>
          <img src="/static/img/lp/campaign/lineCampaign202110/no2.svg" alt="2">
          今週の運勢をお届け！
        </h3>
        <p>あなたの日常に寄り添う毎日の占いが見られます。</p>
        <img src="/static/img/lp/campaign/lineCampaign202110/subscContents2.png">
      </li>
      <li>
        <h3>
          <img src="/static/img/lp/campaign/lineCampaign202110/no3.svg" alt="3">
          メンバーシップコンテンツ
        </h3>
        <p>さらに、『占いTV』月額会員の方がLINE友だちになると、限定コンテンツが見られます！<br>『占いTV』をより使いこなすヒントがたくさん！</p>
      </li>
    </ol>
  </div>
</template>

<script>

export default {
  name: 'BlockSubscContents',
}
</script>

<style scoped lang="scss">
.block-subsc-contents {
  padding: 60px 20px 60px;
  ol {
    list-style: none;
    padding: 0;
    margin: 0;
    counter-reset: item;
    li {
      .img1 {
        width: 100%;
        margin: 8px auto 0;
      }
      .img2 {
        width: 100%;
        margin: 8px auto 0;
      }
    }
    li + li {
      margin: 23px 0 0 0;
    }
    h3 {
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      margin: 0 0 8px;
      font-feature-settings: "palt";
      letter-spacing: 0.7px;
      > img {
        display: inline;
        vertical-align: -9px;
        margin: 0 2px 0 0;
      }
    }
  }
  img {
    display: block;
    max-width: 100%;
    margin: 8px 0 0;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/campaign/LineCampaign202110/blocks/BlockSubscContents.vue